module.exports = __webpack_public_path__ + "static/profile-pic-3c730713329b28471c54d66a253a1c66.jpg";